import { normalizeChord } from './chord';
import { keybindingCommandIds } from './defaultKeybindings';
import type {
  KeybindingCommandId,
  KeybindingOverrides,
  KeybindingScheme,
  Keymap,
  Platform,
} from './keybindingTypes';

function normalizedChords(chords: readonly string[]): string[] {
  return [...new Set(chords.map(normalizeChord).filter((chord): chord is string => chord !== null))];
}

export function resolveKeymap(
  scheme: KeybindingScheme,
  overrides: KeybindingOverrides,
  targetPlatform: Platform,
): Keymap {
  return Object.fromEntries(keybindingCommandIds.map((commandId) => {
    const override = Object.prototype.hasOwnProperty.call(overrides, commandId)
      ? overrides[commandId]
      : undefined;
    const inherited = scheme.defaults[commandId][targetPlatform];
    // null is an invalid persisted value and has the same effect as absence.
    const chords = Array.isArray(override) ? override : inherited;
    return [commandId, normalizedChords(chords)];
  })) as unknown as Record<KeybindingCommandId, readonly string[]>;
}
